import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-graphic-design',
  templateUrl: './graphic-design.component.html',
  styleUrls: ['./graphic-design.component.css']
})
export class GraphicDesignComponent {
constructor(private titleServvice:Title,private metaService: Meta){}

  ngOnInit(): void {
    this.titleServvice.setTitle(' Creative Graphic Design Agency in Hyderabad | Stand Out with Us')
    this.metaService.addTags([
      { name: 'description', content: 'Hyderabads creative graphic design experts are here to help your brand stand out. From logos to marketing materials, we design solutions that captivate and inspire.' },
      { name: 'keywords', content: 'Best Graphic Design Company in Hyderabad ' }
    ]);
  }
}